import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { Placeholder } from "rsuite";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faPlus,
  faPen,
  faTimes,
  faUndo,
  faMinus,
  faEye,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import apiUrl from "../../apiUrlConstant";
import { Formik, Form, Field, ErrorMessage } from "formik";
import DataTable, {
  createTheme,
  defaultThemes,
} from "react-data-table-component";
import datatableOptions from "../../layout/datatableConstants";
import { Link } from "react-router-dom";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

function removeLease(leaseId, ths) {
  confirmAlert({
    title: "Confirm to delete",
    message: "Are you sure you want to delete this prospect.",
    buttons: [
      {
        label: "Yes",
        onClick: () => {
          axios({
            method: "post",
            url: `${apiUrl.apiUrl.url}/prospect/remove-prospect`,
            data: { prospectId: leaseId },
          }).then(function (response) {
            console.log(response, "response", ths);
            counter = Math.round();
            ths.resetCounter();
            ths.loadLeaseCountStatuswise();
          });
        },
      },
      {
        label: "No",
        onClick: () => {
          console.log("cancel clicked");
          //this.loadLeaseCountStatuswise();
        },
      },
    ],
  });
}

var counter = Math.round();

function DeleteBtn(props) {
  console.log(props, "props");
  return (
    (props.status == 0 && props.is_dropped == 0) && (
      <span
        className="tableActionDelete"
        onClick={() => removeLease(props.leaseId, props.ths)}
      >
        <FontAwesomeIcon icon={faTrashAlt} />
      </span>
    )
  );
}



const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  columns={columns}
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#003970;
`;

const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <>
    <TextField
      id="search"
      type="text"
      placeholder="Search"
      aria-label="Search Input"
      value={filterText}
      onChange={onFilter}
      className="searchBtn"
    />
    <ClearButton type="button" onClick={onClear}>
      <FontAwesomeIcon icon={faSearch} />
    </ClearButton>
  </>
);

const ProspectListingTable = ({ asset, brand, status, isDropped, ths }) => {
  console.log(isDropped, "is dropped");
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);

  React.useEffect(() => {
    fetchUsers(1);
  }, [filterText]);

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => {
          setFilterText(e.target.value);
        }}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const fetchUsers = async (page) => {
    setLoading(true);

    const response = await axios.get(
      `${apiUrl.apiUrl.url}/lease-view/get-all-prospects?asset=${asset}&brand=${brand}&page=${page}&per_page=${perPage}&delay=1&term=${filterText}&status=${status}&isDropped=${isDropped}`
    );

    setData(response.data.data);
    setTotalRows(response.data.total);
    setLoading(false);
  };

  const handlePageChange = (page) => {
    fetchUsers(page);

  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);

    const response = await axios.get(
      `${apiUrl.apiUrl.url}/lease-view/get-all-prospects?asset=${asset}&brand=${brand}&page=${page}&per_page=${newPerPage}&delay=1&status=${status}&isDropped=${isDropped}`
    );

    setData(response.data.data);
    setPerPage(newPerPage);
    setLoading(false);
  };

  useEffect(() => {
    fetchUsers(1);
  }, []);

  const columns = [
    {
      name: "S.No",
      selector: "srNo",
      sortable: false,
      grow: 1,
    },
    {
      name: "Prospect Id",
      selector: "leaseCode",
      sortable: false,
      grow: 3,
      wrap: true,
    },
    {
      name: "Asset Name",
      selector: "assetName",
      sortable: false,
      grow: 3,
      wrap: true,
    },
    {
      name: "BrandName",
      selector: "brandName",
      sortable: false,
      grow: 3,
      wrap: true,
    },

    {
      name: "Action",
      grow: 1,
      // selector: "info",
      sortable: false,
      cell: (record) => {
        if (record.status == 1) {
          return (
            <span className="tableActionEdit">
              <Link to={`/createlease/prospect/view/${record.leaseId}`}>
                {" "}
                <FontAwesomeIcon icon={faEye} />
              </Link>
            </span>
          );
        } else {
          return (
            <div>
              <span className="tableActionEdit">
                <Link to={`/createlease/prospect/${record.leaseId}`}>
                  {" "}
                  <FontAwesomeIcon icon={faPen} />
                </Link>
              </span> 
              
              <span className="tableActionEdit">
                <Link to={`/createlease/prospect/view/${record.leaseId}`}>
                  {" "}
                  <FontAwesomeIcon icon={faEye} />
                </Link>
              </span>



              {/* <DeleteBtn
                status={record.status}
                leaseId={record.leaseId}
                is_dropped={record.is_dropped}
                ths={ths}
              ></DeleteBtn> */}
            </div>
          );
        }
      },
    },
  ];

  return (
    <div className="tableContainer">
      <DataTable
        
        columns={columns}
        data={data}
        customStyles={datatableOptions.datatableOptions.customStyle}
        progressPending={loading}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangeRowsPerPage={handlePerRowsChange}
        subHeader
        subHeaderComponent={subHeaderComponentMemo}
        onChangePage={handlePageChange}
        paginationComponentOptions={
          datatableOptions.datatableOptions.paginationOptions
        }
      />
    </div>
  );
};
export default ProspectListingTable;
